import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ResponseRegions } from "src/app/models/shared/response-regions";
import { RecommendationService } from "src/app/services/recommendation/recommendation.service";
import { RegionService } from "src/app/services/region/region.service";

@Injectable()
export class RegionResolver  {

    constructor(private regionService: RegionService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Observable<ResponseRegions>> {
        const response = this.regionService.getRegions()
            .pipe(map(response => {
                if (response.success) {
                    return response.payload;
                }
                else {
                    return <ResponseRegions>{
                        options: [],
                        defaultOption: null,
                        lockRegion: false
                    };
                }
            }));
        const responsePromise = new Promise<Observable<ResponseRegions>>((resolve, reject) => { resolve(response) });
        return responsePromise;
    }

}